/**
 * The key module used by PROXY builds — deliberately empty.
 *
 * `vite.config.ts` aliases `./geminiKey.local` to this file whenever
 * `VITE_GEMINI_PROXY` is set, so the real key file is never read by the
 * bundler and cannot end up in the JavaScript that ships to a phone.
 *
 * This is an alias swap rather than a `?:` in config/index.ts because that was
 * tried and MEASURABLY FAILED: `import.meta.env.VITE_GEMINI_PROXY` is replaced
 * with a literal, but the `.replace()` normalising it made the expression
 * non-constant, so the ternary never folded and the key stayed in the bundle.
 * A file the bundler never opens cannot leak.
 */
export const GEMINI_API_KEY = '';
